module.exports = __webpack_public_path__ + "static/media/travel-bg-right.c83dc045.jpg";